module.exports = __webpack_public_path__ + "images/186_160.jpg";